export const ACCELERATE_EXPERIMENT_EVENT_NAME = "Accelerate_upgrade"
export const PLANS_EXPERIMENT_EVENT_NAME = "Pro_plan_upgrade"
export const CURRENT_PAGE = "CURRENT_PAGE"
